import guldenLogo from "../../assets/gulden-logo.png";
import mawibaLogo from "../../assets/mawiba-logo.png";
import pekipLogo from "../../assets/pekip-logo.png";
import babystepsLogo from "../../assets/baby-steps-logo.png";
import bibebaLogo from "../../assets/bibeba-logo.png";

/* Topic photography (320x240), shot to one style so the grid reads as a set. */
import babyschwimmenPhoto from "../../assets/pampers/suggestions/babyschwimmen.jpg";
import babymassagePhoto from "../../assets/pampers/suggestions/babymassage.jpg";
import trageberatungPhoto from "../../assets/pampers/suggestions/trageberatung.jpg";
import stillberatungPhoto from "../../assets/pampers/suggestions/stillberatung.jpg";
import beikostberatungPhoto from "../../assets/pampers/suggestions/beikostberatung.jpg";
import krabbelgruppePhoto from "../../assets/pampers/suggestions/krabbelgruppe.jpg";
import delfiPhoto from "../../assets/pampers/suggestions/delfi.jpg";
import babysignalPhoto from "../../assets/pampers/suggestions/babysignal.jpg";
import nappydancersPhoto from "../../assets/pampers/suggestions/nappydancers.jpg";
import babyzeichensprachePhoto from "../../assets/pampers/suggestions/babyzeichensprache.jpg";
import rueckbildungPhoto from "../../assets/pampers/suggestions/rueckbildung.jpg";
import geburtsvorbereitungPhoto from "../../assets/pampers/suggestions/geburtsvorbereitung.jpg";
import schlafcoachingPhoto from "../../assets/pampers/suggestions/schlafcoaching.jpg";
import wochenbettPhoto from "../../assets/pampers/suggestions/wochenbett.jpg";
import ersteHilfePhoto from "../../assets/pampers/suggestions/erste-hilfe.jpg";
import yogaMitKindPhoto from "../../assets/pampers/suggestions/yoga-mit-kind.jpg";

/*
 * Brand assets. To swap the partner artwork, replace the file in
 * src/assets/pampers/ and repoint the import — nothing else needs to change.
 * brandLogo is 244x76; see BrandHeader for the height that implies.
 */
import brandLogo from "../../assets/pampers/logo.png";
import brandBackground from "../../assets/pampers/background.jpg";
import kikudooLogo from "../../assets/kikudoo-logo.png";

export { brandLogo, brandBackground, kikudooLogo };

/*
 * The two configurable brand colors.
 *
 * primary   — the partner's brand color: fills buttons and brand surfaces, sits
 *             behind the background image as its color fallback, and colors
 *             text drawn on top of `secondary`.
 * secondary — the color that carries `primary`: text and icons drawn on top of
 *             it, and the ground beneath primary-colored text.
 *
 * Every other shade on the page is derived from these two, so changing them
 * here is enough to re-skin the page for another cooperation partner.
 */
export const BRAND = {
  primary: "#4DA8A5",
  secondary: "#FFFFFF",
};

/* Filters this page pins for every request, regardless of the visible UI.
 * Pampers Club is a baby audience, so the age filter is fixed rather than
 * exposed. Kept local to the page — never written to the shared (persisted)
 * search filters, which belong to /search. */
export const BASE_FILTERS = Object.freeze({
  ageGroups: ["baby"],
  bookable: true,
  categorySpaces: [],
  locationTypes: ["on_site", "online", "home", "by_arrangement"],
});

export const MAX_PRICE = 500;

/* How many suggestion tiles show before the expand toggle. */
export const VISIBLE_SUGGESTIONS = 8;

/*
 * Search suggestions — the baby-space subset of the global autocomplete list
 * (SUGGESTIONS in src/pages/SearchMap/SearchMap.js). `name` is submitted
 * verbatim as the search term, so each one must stay spelled as it is there.
 *
 * `image` is optional: tiles without one render a branded panel built from the
 * topic's initial, so the grid stays presentable until artwork arrives. Add new
 * artwork to src/assets/pampers/suggestions/ and import it here.
 */
export const BABY_SUGGESTIONS = [
  { name: "Babyschwimmen", image: babyschwimmenPhoto, photo: true },
  { name: "Babymassage", image: babymassagePhoto, photo: true },
  { name: "MAWIBA", image: mawibaLogo },
  { name: "PEKiP", image: pekipLogo },
  { name: "Trageberatung", image: trageberatungPhoto, photo: true },
  { name: "Stillberatung", image: stillberatungPhoto, photo: true },
  { name: "Beikostberatung", image: beikostberatungPhoto, photo: true },
  { name: "Krabbelgruppe", image: krabbelgruppePhoto, photo: true },
  { name: "DELFI", image: delfiPhoto, photo: true },
  { name: "babySignal", image: babysignalPhoto, photo: true },
  { name: "nappydancers®", image: nappydancersPhoto, photo: true },
  { name: "Babyzeichensprache", image: babyzeichensprachePhoto, photo: true },
  { name: "Rückbildung", image: rueckbildungPhoto, photo: true },
  { name: "Geburtsvorbereitung", image: geburtsvorbereitungPhoto, photo: true },
  { name: "Schlafcoaching", image: schlafcoachingPhoto, photo: true },
  { name: "Wochenbett", image: wochenbettPhoto, photo: true },
  { name: "Erste-Hilfe", image: ersteHilfePhoto, photo: true },
  { name: "Yoga mit Kind", image: yogaMitKindPhoto, photo: true },
  { name: "BabySteps", image: babystepsLogo },
  { name: "BiBeBa", image: bibebaLogo },
  { name: "Elke Gulden Institut", image: guldenLogo },
];
